// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"c8587e2d","278":"1d0fb053","405":"c01986e2","488":"f2f58a21","596":"a079426d","604":"019b9e8f","748":"34af6335","841":"d5a12c68","885":"6f353723"}[chunkId] + ".chunk.js";
};